import React, { Suspense, useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import { useGlobalStore } from '@robing-org/common-lib'
import '../../src/App.css'
import { SafetyCertificateOutlined,ShoppingCartOutlined,AlertOutlined,BarChartOutlined,BankOutlined,CalendarOutlined,InboxOutlined,ToolOutlined,DashboardOutlined,ArrowLeftOutlined,ReadOutlined,FundOutlined,HomeOutlined,AppstoreOutlined    } from '@ant-design/icons'
type AppRoute = {
  path: string

  // 兼容你现在写法
  icon?: string

  element?: React.LazyExoticComponent<React.FC<any>>

  meta?: {
    title?: string
    icon?: string
    key?: string
    isMenuVisible?: boolean
    order?: number
  }

  children?: AppRoute[]
}
// ---------------- Lazy Route 封装 ----------------
const LazyRoute = (Component: React.LazyExoticComponent<React.FC<any>>) => (
  <Suspense fallback={
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>加载中...</p>
    </div>
  }>
    <Component />
  </Suspense>
)

const HomePage = React.lazy(() => import('../pages/base/Home/HomePage'))
const LoginPage = React.lazy(() => import('../pages/base/Login/LoginPage'))
const QuickLogin = React.lazy(() => import('../pages/base/Login/QuickLogin'))

const AutoLoginPage = React.lazy(() => import('../pages/base/Login/AutoLoginPage'))
const LabHome = React.lazy(() => import('../pages/learn/LabIndex'))
const LabDetail = React.lazy(() => import('../pages/learn/LabIndexDetail'))
const LabNoticeDetail = React.lazy(() => import('../pages/learn/LabNoticeDetail'))
const LabNoticeList = React.lazy(() => import('../pages/learn/LabNoticeList'))

const MessageCenter = React.lazy(() => import('../pages/base/Message/MessageCenter'))


const PageException = React.lazy(() => import('../pages/base/Exception/PageException'))
const LabsInfo = React.lazy(() => import('../pages/assets/labInfo/LabQuery'))
const LabSchedule = React.lazy(() => import('../pages/course/labSchedule/LabSchedule'))
const LabReservation = React.lazy(() => import('../pages/course/labReservation/LabReservation'))


const LabPanel = React.lazy(() => import('../pages/assets/labInfo/LabPanel'))
// const ViewLabForm = React.lazy(() => import('../pages/assets/labInfo/ViewLabForm.tsx1'))

const UserQuery = React.lazy(() => import('../pages/assets/userInfo/UserQuery'))
const Organization = React.lazy(() => import('../pages/assets/organization'))
const LabBatchUserAssign = React.lazy(() => import('../pages/assets/labInfo/batchAssigin/LabBatchUserAssign'))
const LabsChangeQuery = React.lazy(() => import('../pages/assets/labChangeRequest/LabsChangeQuery'))
const LabBusinessApplySubmit = React.lazy(() => import('../pages/assets/labChangeRequest/LabBusinessApplySubmit'))


const LabIndex = React.lazy(() => import('../pages/assets/LabIndex'))
const LabImportWizard = React.lazy(() => import('../pages/assets/wizard/LabImportWizard'))
const LabsRiskQuery = React.lazy(() => import('../pages/assets/labRiskAudit/LabsRiskAuditQuery'))
const LabRiskAssessment = React.lazy(() => import('../pages/assets/labRiskAudit/RiskAuditSubmit'))
const LabNoticeQuery = React.lazy(() => import('../pages/assets/notice/LabNoticeQuery'))
// const LabCoursesQuery = React.lazy(() => import('../pages/assets/labCourses/LabCourses'))
const LabProjectQuery = React.lazy(() => import('../pages/assets/labCourses/LabProjects'))
const LabExperimentQuery = React.lazy(() => import('../pages/assets/labCourses/LabExperiment'))
// const LabBatch = React.lazy(() => import('../pages/assets/labInfo/batchAssigin/LabBatchAdmin'))
const LabLocations = React.lazy(() => import('../pages/assets/labLocation/LabLocations'))
const LabCourseManage = React.lazy(() => import('../pages/course/labCourse/LabCourseManage'))

const LabAssetCategory = React.lazy(() => import('../pages/assets/instruments/LabAssetCategory'))
const MyApplyAssetQuery = React.lazy(() => import('../pages/repair/request/MyApplyAssetQuery'))
const RepairQuery = React.lazy(() => import('../pages/repair/request/RepairQuery'))
const RepairSubmit = React.lazy(() => import('../pages/repair/request/RepairSubmit'))
const RepairInstrumentQuery = React.lazy(() => import('../pages/repair/instrument/RepairInstrumentTask'))
const RepairDetail = React.lazy(() => import('../pages/repair/instrument/RepairTaskDetail'))
const AnalysisPage = React.lazy(() => import('../pages/repair/report/AnalysisPage'))
const RepairLedgerQuery = React.lazy(() => import('../pages/repair/report/RepairLedgerQuery'))
const RepairFaultQuery = React.lazy(() => import('../pages/repair/instrument/RepairFaultQuery'))


const PurchaseQuery = React.lazy(() => import('../pages/cons/purchase/PurchaseQuery'))
const PurchaseOrder = React.lazy(() => import('../pages/cons/purchase/PurchaseOrderSubmit'))
const PurchaseConsQuery = React.lazy(() => import('../pages/cons/purchase/PurchaseConsQuery'))

const PurchasePendingInList = React.lazy(() => import('../pages/cons/in/PurchasePendingInList'))
const ConsStockInSubmit = React.lazy(() => import('../pages/cons/in/ConsStockInSubmit'))
const ConsStockInQuery = React.lazy(() => import('../pages/cons/in/ConsStockInQuery'))
const ConsStockQuery = React.lazy(() => import('../pages/cons/stock/ConsStockQuery'))
const ConsStockOutQuery = React.lazy(() => import('../pages/cons/out/ConsStockOutQuery'))
const ConsStockOutSubmit = React.lazy(() => import('../pages/cons/out/ConsStockOutSubmit'))
const ConsOutboundList = React.lazy(() => import('../pages/cons/out/ConsOutboundList'))
const ConsApplyOutStock = React.lazy(() => import('../pages/cons/out/ConsApplyOutStock'))
const ConsCategoryManager = React.lazy(() => import('../pages/cons/setting/ConsCategoryManager'))
const MyApplyConsList = React.lazy(() => import('../pages/cons/out/MyApplyConsList'))
const MyPicketConsList = React.lazy(() => import('../pages/cons/use/MyPicketConsList'))
const ReturnableConsList = React.lazy(() => import('../pages/cons/use/ReturnableConsList'))
const ReturnConsList = React.lazy(() => import('../pages/cons/use/ReturnConsList'))
const ReturnConsManager = React.lazy(() => import('../pages/cons/stock/ReturnConsAdmin'))
const ConsDisposalQuery = React.lazy(() => import('../pages/cons/disposal/ConsDisposalQuery'))
const ConsDisposalSubmit = React.lazy(() => import('../pages/cons/disposal/ConsDisposalSubmit'))
const ConsInventoryCheckQuery = React.lazy(() => import('../pages/cons/stock/ConsInventoryCheckQuery'))
const ConsInventoryCheckEdit = React.lazy(() => import('../pages/cons/stock/ConsInventoryCheckEdit'))
const ConsReportQuery = React.lazy(() => import('../pages/cons/report/ConsReportQuery'))

const ConsStockReport = React.lazy(() => import('../pages/cons/report/ConsStockReport'))
const ConsConsumeReport = React.lazy(() => import('../pages/cons/report/ConsConsumeTrendReport'))


const consHome = React.lazy(() => import('../pages/cons/ConsHome'))

const ExamQuestion = React.lazy(() => import('../pages/safety/examQuestion/Question'))
const LearningCategory = React.lazy(() => import('../pages/safety/courses/LearningCategory'))

const RiskCategory = React.lazy(() => import('../pages/safety/riskCategory/RiskCategory'))
const Assessment = React.lazy(() => import('../pages/safety/assessment/Assessment'))
const LabMonitorPage = React.lazy(() => import('../pages/monitor/LabMonitorPage'))
const UserSessionLogQuery = React.lazy(() => import('../pages/monitor/UserSessionLogQuery'))
const UnboundDeviceQuery = React.lazy(() => import('../pages/monitor/UnboundDeviceQuery'))

const ExamRecord = React.lazy(() => import('../pages/safety/examRecord/ExamRecord'))
const ExamAnswer = React.lazy(() => import('../pages/learn/exam/ExamAnswer'))
const CertificateQuery = React.lazy(() => import('../pages/safety/certificate/CertificateQuery'))
const CertificateLedgerQuery = React.lazy(() => import('../pages/safety/report/PersonLedgerQuery'))
const LearningSummary = React.lazy(() => import('../pages/safety/report/LearningSummary'))


const learningHome = React.lazy(() => import('../pages/safety/LearningHome'))
const LearningQuery = React.lazy(() => import('../pages/safety/courses/SafeLearningQuery'))
const LearnContentDetail = React.lazy(() => import('../pages/learn/LearnContentDetail'))
const LearnSearchPage = React.lazy(() => import('../pages/learn/SearchPage'))
const LabCourseHome = React.lazy(() => import('../pages/learn/LabCourseHome'))
const LearnCategoryVideos = React.lazy(() => import('../pages/learn/LearnCategoryVideos'))
const MockExam = React.lazy(() => import('../pages/learn/mock/MockExam'))
const MyMockExam = React.lazy(() => import('../pages/learn/my/MyMockExamHistory'))


const LabCourseStudy = React.lazy(() => import('../pages/learn/LabCourseStudy'))
const LearnCategoryList = React.lazy(() => import('../pages/learn/LearnCategoryList'))
const MyLearnLessons = React.lazy(() => import('../pages/learn/my/MyLearnLessons'))
const StudentLabCalendar = React.lazy(() => import('../pages/learn/StudentLabCalendar'))
const StudentLabInstrument = React.lazy(() => import('../pages/learn/StudentLabInstrument'))
const CertificateVerifyResult = React.lazy(() => import('../pages/learn/CertificateVerifyResult'))
const MyExamsHistory = React.lazy(() => import('../pages/learn/my/MyExamsHistory'))
const MyExperimentSchedule = React.lazy(() => import('../pages/learn/my/MyExperimentSchedule'))
const MyLabReservations = React.lazy(() => import('../pages/learn/my/MyLabReservations'))

const InspectionQuery = React.lazy(() => import('../pages/safetyInspection/inspection/InspectionQuery'))
const InspectionCreate = React.lazy(() => import('../pages/safetyInspection/inspection/InspectionCreate'))
const RectificationQuery = React.lazy(() => import('../pages/safetyInspection/inspection/RectificationQuery'))
const HazardQuery = React.lazy(() => import('../pages/safetyInspection/inspection/HazardQuery'))

const MySafetyHazardQuery = React.lazy(() => import('../pages/safetyInspection/inspection/MySafetyHazardQuery'))
const MySubmitSafetyHazardQuery = React.lazy(() => import('../pages/safetyInspection/inspection/MySubmitSafetyHazardQuery'))
const LabSafetyReportPage = React.lazy(() => import('../pages/safetyInspection/inspection/LabSafetyReportPage'))

const CheckStandardQuery = React.lazy(() => import('../pages/safetyInspection/checkStandard/ChecksQuery'))
const InspectionPlan = React.lazy(() => import('../pages/safetyInspection/inspection/InspectionPlanQuery'))
const InspectionPlanSubmit = React.lazy(() => import('../pages/safetyInspection/inspection/InspectionPlanSubmit'))
const InspectionLedgerQuery = React.lazy(() => import('../pages/safetyInspection/inspection/InspectionLedgerQuery'))
const HazardHome = React.lazy(() => import('../pages/safetyInspection/InspectionHome'))

const SJ1 = React.lazy(() => import('../pages/updata/sj1/Instruments'))
const SJ2 = React.lazy(() => import('../pages/updata/sj2/InstrumentSummary'))
const SJ3 = React.lazy(() => import('../pages/updata/sj3/ValuableInstruments'))
const SJ4 = React.lazy(() => import('../pages/updata/sj4/ExperimentProject'))
const SJ5 = React.lazy(() => import('../pages/updata/sj5/SJ5Staff'))
const SJ6 = React.lazy(() => import('../pages/updata/sj6/SJ6LabInfo'))
const SJ7 = React.lazy(() => import('../pages/updata/sj7/LabFunding'))
const SJPanel = React.lazy(() => import('../pages/updata/sjdata/Panel'))
const DataGovTree = React.lazy(() => import('../pages/updata/gov/DataGovTree'))
const DataGovInventoryPlan = React.lazy(() => import('../pages/updata/inventory/InventoryPlan'))
const InventoryPlanEdit = React.lazy(() => import('../pages/updata/inventory/InventoryPlanEdit'))

const MyInventoryTasks = React.lazy(() => import('../pages/updata/inventory/MyInventoryItemTask'))
const InventoryItemPage = React.lazy(() => import('../pages/updata/inventory/MyInventoryItemTaskDetail'))

const RoleUsersQuery = React.lazy(() => import('../pages/assets/userInfo/RoleUsersQuery'))
const RoleQuery = React.lazy(() => import('../pages/setting/userRole/RoleQuery'))

const FlowApprove = React.lazy(() => import('../pages/setting/flow/flowApprove'))
const Dict = React.lazy(() => import('../pages/setting/dict/dict'))

const ViewPermission = React.lazy(() => import('../pages/setting/viewPermission/Query'))


// ---------------- 路由配置 ----------------
export const routeConfig: AppRoute[] = [
  { path: '/home', element: HomePage, meta: { title: '实验室综合平台', icon: 'AppstoreOutlined', key: 'home', isMenuVisible: true, order: 1 } },
  {
    path: '/labBase',
    meta: { title: '实验室基础信息', icon: 'BankOutlined', key: 'labBase', isMenuVisible: true, order: 1 },
    children: [
      { path: '/labBase/home',icon: 'HomeOutlined',element: LabIndex, meta: { title: '实验室管控台',  key: 'labBase.index', isMenuVisible: true, order: 1 } },
       
      { path: '/labBase/labPanel', icon: 'TableOutlined', element: LabPanel, meta: { title: '基础信息与安全', key: 'labBase.labsPanel', isMenuVisible: true, order: 1 } },
      { path: '/labBase/riskAuditSubmit', icon: 'DashboardOutlined', element: LabRiskAssessment, meta: { title: '分级分类申请', key: 'labBase.labRiskAssessment', isMenuVisible: false, order:3 } },
      { path: '/labBase/labsChangeQuery', icon: 'DashboardOutlined', element: LabsChangeQuery, meta: { title: '业务申请', key: 'labBase.labChangeRequest', isMenuVisible: true, order:4 } },
      { path: '/labBase/labBusinessApplySubmit', icon: 'DashboardOutlined', element: LabBusinessApplySubmit, meta: { title: '业务申请', key: 'labBase.labChangeRequest', isMenuVisible: false, order:4 } },
      

      
      { path: '/labBase/labsRiskAuditQuery', icon: 'DashboardOutlined', element: LabsRiskQuery, meta: { title: '分级分类', key: 'labBase.labsPanel', isMenuVisible: true, order:4 } },
      { path: '/labBase/labBatchAssign', icon: 'DashboardOutlined', element: LabBatchUserAssign, meta: { title: '实验室配置使用人员', key: 'labBase.labsPanel.batchSetting', isMenuVisible: false, order:6 } },
     
      { path: '/labBase/instrumentsCategory', icon: 'TableOutlined', element: LabAssetCategory, meta: { title: '设备管理', key: 'labBase.instruments.category', isMenuVisible: true, order: 21 } },
      { path: '/labBase/userQuery', icon: 'DashboardOutlined', element: UserQuery, meta: { title: '人员管理', key: 'labBase.userQuery', isMenuVisible: true, order: 41 } },
      // { path: '/labBase/courses', icon: 'TableOutlined', element: LabCoursesQuery, meta: { title: '实验课程', key: 'labBase.academicAffairs', isMenuVisible: false, order:31 } },
      
      { path: '/labBase/roleUsersQuery', icon: 'DashboardOutlined', element: RoleUsersQuery, meta: { title: '用户角色', key: 'labBase.userAndRole', isMenuVisible: true, order: 42 } },
      { path: '/labBase/organization', icon: 'DashboardOutlined', element: Organization, meta: { title: '机构设置', key: 'labBase.organization', isMenuVisible: true, order: 51 } },
      { path: '/labBase/labLocation', icon: 'DashboardOutlined', element: LabLocations, meta: { title: '实验场所', key: 'labBase.labsPanel.settingLocation', isMenuVisible: true, order:55} },
      
      { path: '/labBase/labImportWizard', icon: 'TableOutlined', element: LabImportWizard, meta: { title: '数据导入', key: 'labBase.dataAdmin', isMenuVisible: true, order:80 } },
      
      
    ]
  },
  {
    path: '/course',
    meta: { title: '课表与预约', icon: 'BankOutlined', key: 'course', isMenuVisible: true, order: 1 },
    children: [
      { path: '/course/noticeQuery', icon: 'TableOutlined', element: LabNoticeQuery, meta: { title: '通知管理', key: 'course.notice', isMenuVisible: true, order:4 } },
      { path: '/course/labSchedule', icon: 'TableOutlined', element: LabSchedule, meta: { title: '实验课表', key: 'course.courseSchedule', isMenuVisible: true, order:11 } },
      { path: '/course/labReservation', icon: 'TableOutlined', element: LabReservation, meta: { title: '预约管理', key: 'course.labReservation', isMenuVisible: true, order:31 } },
      { path: '/course/LabExperimentQuery', icon: 'TableOutlined', element: LabExperimentQuery, meta: { title: '实验名称', key: 'course.labReservation', isMenuVisible: true, order:34 } },
      { path: '/course/labProjectQuery', icon: 'TableOutlined', element: LabProjectQuery, meta: { title: '实验项目', key: 'course.labReservation', isMenuVisible: true, order:32 } },
      { path: '/course/courses', icon: 'TableOutlined', element: LabCourseManage, meta: { title: '课程库', key: 'course.labReservation', isMenuVisible: true, order:36} }
      
    ]
  },
  {
    path: '/labMonitor',
    meta: { title: '实验室使用监控', icon: 'DesktopOutlined', key: 'labMonitor', isMenuVisible: true, order: 2 },
    children: [
      { path: '/labMonitor/labsOverview', icon: 'TableOutlined', element: LabMonitorPage, meta: { title: '实验室准入监控', key: 'labMonitor.labUsesClient', isMenuVisible: true, order: 1 } },
      { path: '/labMonitor/terminalUsage', icon: 'TableOutlined', element: UserSessionLogQuery, meta: { title: '实验室终端使用日志', key: 'labMonitor.labUsesClient', isMenuVisible: true, order: 1 } },
      { path: '/labMonitor/unboundDevice', icon: 'TableOutlined', element: UnboundDeviceQuery, meta: { title: '未绑定实验室终端', key: 'labMonitor.unboundDevice', isMenuVisible: true, order: 1 } },
       
    ]
  },
  {
    path: '/updata',
    meta: { title: '实验室数据上报', icon: 'DesktopOutlined', key: 'updata', isMenuVisible: true, order: 1 },
    children: [
      { path: '/updata/sj1', icon: 'TableOutlined', element: SJ1, meta: { title: 'SJ1教仪设备表', key: 'updata.sj1query', isMenuVisible: true, order: 1 } },
      { path: '/updata/sj2', icon: 'TableOutlined', element: SJ2, meta: { title: 'SJ2设备增减变动表', key: 'updata.sj2query', isMenuVisible: true, order: 1 } },
      { path: '/updata/sj3', icon: 'TableOutlined', element: SJ3, meta: { title: 'SJ3贵重仪器设备表', key: 'updata.sj3query', isMenuVisible: true, order: 1 } },
      { path: '/updata/sj4', icon: 'TableOutlined', element: SJ4, meta: { title: 'SJ4教学实验项目', key: 'updata.sj4query', isMenuVisible: true, order: 1 } },
      { path: '/updata/sj5', icon: 'TableOutlined', element: SJ5, meta: { title: 'SJ5专任实验室人员', key: 'updata.sj5query', isMenuVisible: true, order: 1 } },
      { path: '/updata/sj6', icon: 'TableOutlined', element: SJ6, meta: { title: 'SJ6实验室基本表', key: 'updata.sj6query', isMenuVisible: true, order: 1 } },
      { path: '/updata/sj7', icon: 'TableOutlined', element: SJ7, meta: { title: 'SJ7实验室经费表', key: 'updata.sj7query', isMenuVisible: true, order: 1 } },
      { path: '/updata/SJPanel', icon: 'TableOutlined', element: SJPanel, meta: { title: 'SJ上报数据检测', key: 'updata.sjPanel', isMenuVisible: true, order: 1 } },
      { path: '/updata/dataGov', icon: 'TableOutlined', element: DataGovTree, meta: { title: '数据治理操作', key: 'updata.dataGov', isMenuVisible: true, order: 1 } },
      { path: '/updata/inventoryPlan', icon: 'TableOutlined', element: DataGovInventoryPlan, meta: { title: '数据核查计划', key: 'updata.inventory', isMenuVisible: true, order: 1 } },
      { path: '/updata/inventoryTaskSubmit', icon: 'TableOutlined', element: InventoryPlanEdit, meta: { title: '数据核查计划', key: 'updata.inventory', isMenuVisible: false, order: 1 } },
      { path: '/updata/myInventoryTasks', icon: 'TableOutlined', element: MyInventoryTasks, meta: { title: '我的数据核查', key: 'updata.MyInventory', isMenuVisible: true, order: 3 } },
      { path: '/updata/inventoryTasksDetail', icon: 'TableOutlined', element: InventoryItemPage, meta: { title: '我的数据核查', key: 'updata.MyInventory', isMenuVisible: false, order: 3 } },
      
      
      
    ]
  },
  {
    path: '/learn',
    meta: { title: '在线学习', icon: 'ReadOutlined', key: 'learn', isMenuVisible: false, order: 5 },
    children: [
      { path: '/learn/home', icon: 'TableOutlined', element: LabCourseHome, meta: { title: '安全课程学习', key: 'learn.view', isMenuVisible: true, order: 1 } },
      { path: '/learn/labCourseStudy/:id', icon: 'TableOutlined', element: LabCourseStudy, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/detail/:id', icon: 'TableOutlined', element: LearnContentDetail, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/detail', icon: 'TableOutlined', element: LearnContentDetail, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/lab/notice/detail', icon: 'TableOutlined', element: LabNoticeDetail, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/lab/notice/list', icon: 'TableOutlined', element: LabNoticeList, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 3 } },
      
      
      { path: '/learn/search', icon: 'TableOutlined', element: LearnSearchPage, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/category', icon: 'TableOutlined', element: LearnCategoryList, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/lessons', icon: 'TableOutlined', element: MyLearnLessons, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/labCalendar', icon: 'TableOutlined', element: StudentLabCalendar, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/labInstrument', icon: 'TableOutlined', element: StudentLabInstrument, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/exam', icon: 'TableOutlined', element: ExamAnswer, meta: { title: '安全考试', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/mockExam', icon: 'TableOutlined', element: MockExam, meta: { title: '安全考试', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/myMockExam', icon: 'TableOutlined', element: MyMockExam, meta: { title: '安全考试', key: 'learn.view', isMenuVisible: false, order: 1 } },
      
      { path: '/learn/myExamsHistory', icon: 'TableOutlined', element: MyExamsHistory, meta: { title: '安全考试', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/learnVideos', icon: 'TableOutlined', element: LearnCategoryVideos, meta: { title: '课程学习', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/myExperiment', icon: 'TableOutlined', element: MyExperimentSchedule, meta: { title: '我的实验课', key: 'learn.view', isMenuVisible: false, order: 1 } },
      { path: '/learn/myReservations', icon: 'TableOutlined', element: MyLabReservations, meta: { title: '我的预约', key: 'learn.view', isMenuVisible: false, order: 1 } },
      
      
    ]
  },
  {
    path: '/safety',
    meta: { title: '安全学习与考试', icon: 'ReadOutlined', key: 'safety', isMenuVisible: true, order: 5 },
    children: [
      { path: '/safety/learningHome', icon: 'TableOutlined', element: learningHome, meta: { title: '教育与考试总览', key: 'safety.learningHome', isMenuVisible: true, order: 1 } },
     
      { path: '/safety/learningQuery', icon: 'TableOutlined', element: LearningQuery, meta: { title: '安全学习课程', key: 'safety.learningSetting', isMenuVisible: true, order: 1 } },
      { path: '/safety/assessment', icon: 'TableOutlined', element: Assessment, meta: { title: '安全考试发布', key: 'safety.assessment', isMenuVisible: true, order: 1 } },
      { path: '/safety/examRecord', icon: 'TableOutlined', element: ExamRecord, meta: { title: '安全考试查询', key: 'safety.examRecord', isMenuVisible: true, order: 1 } },
      { path: '/safety/certificat', icon: 'TableOutlined', element: CertificateQuery, meta: { title: '合格证书查询', key: 'safety.certificat', isMenuVisible: true, order: 1 } },
      { path: '/safety/ledgerQuery', icon: 'TableOutlined', element: CertificateLedgerQuery, meta: { title: '人员台账查询', key: 'safety.ledgerQuery', isMenuVisible: true, order: 1 } },
      { path: '/safety/summary', icon: 'TableOutlined', element: LearningSummary, meta: { title: '综合数据汇总', key: 'safety.ledgerQuery', isMenuVisible: true, order: 1 } },
     
      
      { path: '/safety/examQuestion', icon: 'TableOutlined', element: ExamQuestion, meta: { title: '安全知识题库', key: 'safety.examQuestion', isMenuVisible: true, order: 1 } },
      { path: '/safety/riskCategory', icon: 'TableOutlined', element: RiskCategory, meta: { title: '安全知识分类', key: 'safety.riskCategory', isMenuVisible: true, order: 1 } }
    ]
  },
  {
    path: '/safetyInspection',
    meta: { title: '安全检查与隐患', icon: 'AlertOutlined', key: 'safetyInspection', isMenuVisible: true, order: 6 },
    children: [
      { path: '/safetyInspection/inspectionHome', icon: 'DashboardOutlined', element: HazardHome, meta: { title: '安全检查汇总', key: 'safetyInspection.inspectionHome', isMenuVisible: true, order: 2 } },
      
      { path: '/safetyInspection/inspectionPlan', icon: 'DashboardOutlined', element: InspectionPlan, meta: { title: '安全检查计划', key: 'safetyInspection.plan', isMenuVisible: true, order: 2 } },
      { path: '/safetyInspection/inspectionCreate', icon: 'DashboardOutlined', element: InspectionCreate, meta: { title: '安全检查', key: 'safetyInspection.inspectionCreate', isMenuVisible: false, order: 14 } },
      
      { path: '/safetyInspection/inspectionPlanSubmit', icon: 'DashboardOutlined', element: InspectionPlanSubmit, meta: { title: '安全检查计划', key: 'safetyInspection.plan', isMenuVisible: false, order: 5 } },
      { path: '/safetyInspection/mySafetyHazardQuery', icon: 'DashboardOutlined', element: MySafetyHazardQuery, meta: { title: '我负责的隐患', key: 'safetyInspection.myHazard', isMenuVisible: true, order: 7 } },
      { path: '/safetyInspection/inspectionQuery', icon: 'DashboardOutlined', element: InspectionQuery, meta: { title: '我执行的检查', key: 'safetyInspection.inspectionQuery', isMenuVisible: true, order: 3 } },
      { path: '/safetyInspection/mySubmitHazardQuery', icon: 'DashboardOutlined', element: MySubmitSafetyHazardQuery, meta: { title: '我提交的隐患', key: 'safetyInspection.mySubmitRectification', isMenuVisible: true, order: 4 } },
      
      { path: '/safetyInspection/hazardQuery', icon: 'DashboardOutlined', element: HazardQuery, meta: { title: '隐患审核', key: 'safetyInspection.hazardQuery', isMenuVisible: true, order: 8 } },
      { path: '/safetyInspection/rectificationQuery', icon: 'DashboardOutlined', element: RectificationQuery, meta: { title: '整改复核', key: 'safetyInspection.rectificationQuery', isMenuVisible: true, order: 11 } },
      { path: '/safetyInspection/inspectionLedgerQuery', icon: 'DashboardOutlined', element: InspectionLedgerQuery, meta: { title: '隐患台账查询', key: 'safetyInspection.Ledger', isMenuVisible: true, order: 13 } },
      { path: '/safetyInspection/labSafetyReportPage', icon: 'DashboardOutlined', element: LabSafetyReportPage, meta: { title: '安全报告中心', key: 'safetyInspection.Ledger', isMenuVisible: true, order: 13 } },
     { path: '/safetyInspection/checkStandardQuery', icon: 'DashboardOutlined', element: CheckStandardQuery, meta: { title: '安全检查模板', key: 'safetyInspection.CheckStandard', isMenuVisible: true, order: 22 } },
    ]
  },
  {
    path: '/repair',
    meta: { title: '设备维修管理', icon: 'ToolOutlined', key: 'repair', isMenuVisible: true, order: 5 },
    children: [
      { path: '/repair/myApplyAssets', icon: 'TableOutlined', element: MyApplyAssetQuery, meta: { title: '我报修的设备', key: 'repair.repairSubmit', isMenuVisible: true, order: 1 } },
      { path: '/repair/repairOrderQuery', icon: 'TableOutlined', element: RepairQuery, meta: { title: '设备报修申请', key: 'repair.repairOrderQuery', isMenuVisible: true, order: 2} },
      { path: '/repair/repairSubmit', icon: 'TableOutlined', element: RepairSubmit, meta: { title: '设备报修申请', key: 'repair.repairOrderQuery', isMenuVisible: false, order: 4 } },
      { path: '/repair/repairWorkQuery', icon: 'TableOutlined', element: RepairInstrumentQuery, meta: { title: '设备维修工单', key: 'repair.repairInstrumentQuery', isMenuVisible: true, order: 5} },
      { path: '/repair/repairDetail', icon: 'TableOutlined', element: RepairDetail, meta: { title: '设备维修操作', key: 'repair.repairInstrumentQuery', isMenuVisible: false, order: 6} },
      { path: '/repair/repairLedger', icon: 'TableOutlined', element: RepairLedgerQuery, meta: { title: '设备维修台账', key: 'repair.repairInstrumentReport', isMenuVisible: true, order: 6} },
      { path: '/repair/repairFaultQuery', icon: 'TableOutlined', element: RepairFaultQuery, meta: { title: '故障及维修模板', key: 'repair.repairFaultQuery', isMenuVisible: true, order: 6} },
      { path: '/repair/analysis', icon: 'TableOutlined', element: AnalysisPage, meta: { title: '维修数据中心', key: 'repair.repairInstrumentReport', isMenuVisible: true, order: 7} },
    ]
  },
  {
    path: '/cons',
    meta: { title: '耗材管理', icon: 'ToolOutlined', key: 'cons', isMenuVisible: true, order: 5 },
    children: [
      { path: '/cons/home', icon: 'TableOutlined', element: consHome, meta: { title: '耗材管理汇总', key: 'cons.purchaseQuery', isMenuVisible: true, order: 1 } },
      {
        path: '/cons/purchaseQuery1',
        meta: { title: '申购管理', key: 'cons.purchaseQuery',icon: 'ShoppingCartOutlined', isMenuVisible: true, order: 2  },
        children: [
          { path: '/cons/purchaseQuery', icon: 'TableOutlined', element: PurchaseQuery, meta: { title: '申购申请', key: 'cons.purchaseQuery', isMenuVisible: true, order: 1 } },
          { path: '/cons/purchaseOrderSubmit', icon: 'TableOutlined', element: PurchaseOrder, meta: { title: '耗材申购单', key: 'cons.purchaseQuery', isMenuVisible: false, order: 2 } },
          
          { path: '/cons/purchaseConsQuery', icon: 'TableOutlined', element: PurchaseConsQuery, meta: { title: '申购进度', key: 'cons.purchasePendingInList', isMenuVisible: true, order: 2 } },
          
          { path: '/cons/purchasePendingInList', icon: 'TableOutlined', element: PurchasePendingInList, meta: { title: '申购入库', key: 'cons.purchasePendingInList', isMenuVisible: true, order: 2 } },
          { path: '/cons/consStockInQuery', icon: 'TableOutlined', element: ConsStockInQuery, meta: { title: '入库申请', key: 'cons.stockInQuery', isMenuVisible: true, order: 2 } },
          { path: '/cons/consStockInSubmit', icon: 'TableOutlined', element: ConsStockInSubmit, meta: { title: '入库申请单', key: 'cons.stockInQuery', isMenuVisible: false, order: 2 } },
        ]
      },
      {
        path: '/cons/stockOutQuery1',
        meta: { title: '耗材申领', key: 'cons.stockOutQuery', icon: 'FileProtectOutlined', isMenuVisible: true, order: 2  },
        children: [
          { path: '/cons/consStockOutQuery', icon: 'TableOutlined', element: ConsStockOutQuery, meta: { title: '申领申请', key: 'cons.stockOutQuery', isMenuVisible: true, order: 4 } },
          { path: '/cons/consStockOutSubmit', icon: 'TableOutlined', element: ConsStockOutSubmit, meta: { title: '申领申请', key: 'cons.stockOutQuery', isMenuVisible: false, order: 4 } },
          { path: '/cons/myApplyConsList', icon: 'TableOutlined', element: MyApplyConsList, meta: { title: '我申领的耗材', key: 'cons.myApplyConsList', isMenuVisible: true, order: 4 } },
            
        ]
      },
      {
        path: '/cons/outboundList1',
        meta: { title: '库存管理', key: 'cons.outboundList', icon: 'HddOutlined', isMenuVisible: true, order: 2  },
        children: [
          { path: '/cons/consStockQuery', icon: 'TableOutlined', element: ConsStockQuery, meta: { title: '库存查询', key: 'cons.stockQuery', isMenuVisible: true, order: 1 } },
          { path: '/cons/consOutboundList', icon: 'TableOutlined', element: ConsOutboundList, meta: { title: '耗材出库', key: 'cons.outboundList', isMenuVisible: true, order: 2} },
          { path: '/cons/returnConsManager', icon: 'TableOutlined', element: ReturnConsManager, meta: { title: '回库审核', key: 'cons.stockAdminReturn', isMenuVisible: true, order: 3 } },
          { path: '/cons/consInventoryCheckQuery', icon: 'TableOutlined', element: ConsInventoryCheckQuery, meta: { title: '库存盘点', key: 'cons.inventoryCheck', isMenuVisible: true, order: 4 } },
          { path: '/cons/consDisposalQuery', icon: 'TableOutlined', element: ConsDisposalQuery, meta: { title: '库存处置', key: 'cons.disposal', isMenuVisible: true, order: 5} },
          { path: '/cons/consApplyOutStock', icon: 'TableOutlined', element: ConsApplyOutStock, meta: { title: '申领单出库', key: 'cons.outboundList', isMenuVisible: false, order: 6 } },
          { path: '/cons/consDisposalSubmit', icon: 'TableOutlined', element: ConsDisposalSubmit, meta: { title: '库存处置', key: 'cons.disposal', isMenuVisible: false, order: 7 } },
          { path: '/cons/consCategoryManager', icon: 'TableOutlined', element: ConsCategoryManager, meta: { title: '耗材基础库', key: 'cons.baseData', isMenuVisible: true, order:9 } },
          { path: '/cons/consInventoryCheckEdit', icon: 'TableOutlined', element: ConsInventoryCheckEdit, meta: { title: '耗材盘点', key: 'cons.inventoryCheck', isMenuVisible: false, order: 10 } },
         
        ]
      },
      {
        path: '/cons/useManagement1',
        meta: { title: '使用管理', key: 'cons.useManagement', icon: 'RetweetOutlined', isMenuVisible: true, order: 2  },
        children: [
          { path: '/cons/myPicketConsList', icon: 'TableOutlined', element: MyPicketConsList, meta: { title: '我领用的耗材', key: 'cons.useManagement', isMenuVisible: true, order: 4 } },
          { path: '/cons/returnableConsList', icon: 'TableOutlined', element: ReturnableConsList, meta: { title: '回库登记', key: 'cons.useManagement', isMenuVisible: true, order: 4 } },
          { path: '/cons/returnConsList', icon: 'TableOutlined', element: ReturnConsList, meta: { title: '回库记录', key: 'cons.useManagement', isMenuVisible: true, order: 4 } },
      
        ]
      },
      {
        path: '/cons/report',
        meta: { title: '报表分析', key: 'cons.outboundList', icon: 'BarChartOutlined', isMenuVisible: true, order: 2  },
        children: [
          { path: '/cons/consReportQuery', icon: 'TableOutlined', element: ConsReportQuery, meta: { title: '耗材台账', key: 'cons.consDetailQuery', isMenuVisible: true, order: 4 } },
          { path: '/cons/consStockReport', icon: 'TableOutlined', element: ConsStockReport, meta: { title: '库存分析', key: 'cons.consStockReport', isMenuVisible: true, order: 4 } },
          { path: '/cons/consConsumeReport', icon: 'TableOutlined', element: ConsConsumeReport, meta: { title: '消耗分析', key: 'cons.consConsumeReport', isMenuVisible: true, order: 4 } },
          
          
        ]
      },
    ]
  },
  {
    path: '/setting',
    meta: { title: '系统设置', icon: 'SettingOutlined', key: 'setting', isMenuVisible: true, order: 11 },
    children: [
      { path: '/setting/roleQuery', icon: 'DashboardOutlined', element: RoleQuery, meta: { title: '角色管理', key: 'setting.roleQuery', isMenuVisible: true, order: 17 } },

      { path: '/setting/dict', icon: 'DashboardOutlined', element: Dict, meta: { title: '字典表管理', key: 'setting.dict', isMenuVisible: true, order: 17 } },
      { path: '/setting/viewPermission', icon: 'DashboardOutlined', element: ViewPermission, meta: { title: '视图权限', key: 'setting.viewPermission', isMenuVisible: true, order: 17 } },
      { path: '/setting/flowApprove', icon: 'DashboardOutlined', element: FlowApprove, meta: { title: '流程配置', key: 'setting.flowQuery', isMenuVisible: true, order: 17 } },
      
    ]
  },
  
  
  { path: '/login', element: LoginPage, meta: { title: '登录页', key: 'login', isMenuVisible: false, order: 3 } },
  { path: '/403', element: PageException, meta: { title: '403 - 无权限', key: '403', isMenuVisible: false, order: 0 } },
  { path: '/404', element: PageException, meta: { title: '404 - 页面未找到', key: '404', isMenuVisible: false, order: 0 } }
]

const freeAccessKeys = ['learn.view',"autologin"]

// ---------------- 权限过滤器 ----------------
export const filterRoutesWithPermissions = (
  routes: AppRoute[],
  permissions: Record<string, string[]>
) => {
  const allowedKeys = Object.values(permissions).flat()

  const filterRecursively = (list: any[]): any[] => {
    return list
      .map(route => {
        // ---------- 先过滤 children ----------
        if (route.children) {
          const filteredChildren = filterRecursively(route.children)
          // 只要子节点存在，就保留父节点
          if (filteredChildren.length > 0) {
            return { ...route, children: filteredChildren }
          }
        }
        // ---------- 页面节点判断 ----------
        if (!route.element) return null
        // 白名单
        if (route.meta?.key && freeAccessKeys.includes(route.meta.key)) {
          return route
        }
        // 权限判断
        if (!route.meta?.key || !allowedKeys.includes(route.meta.key)) {
          return null
        }
        return route
      })
      .filter(Boolean)
  }

  return filterRecursively(routes)
}

// ---------------- 生成 Route ----------------
const generateRoutes = (
  routes: AppRoute[],
  allowedKeys: string[]
): React.ReactElement[] =>
  routes.flatMap(route => {

    // 有children继续递归
    if (route.children?.length) {
      return generateRoutes(route.children, allowedKeys)
    }

    if (!route.element || !route.meta?.key) {
      return []
    }

    if (freeAccessKeys.includes(route.meta.key)) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={LazyRoute(route.element)}
        />
      )
    }

    if (!allowedKeys.includes(route.meta.key)) {
      return []
    }

    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          <PrivateRoute
            element={LazyRoute(route.element)}
          />
        }
      />
    )
  })

// ---------------- RoutesComponent ----------------
const RoutesComponent: React.FC = () => {
  const token = useGlobalStore.getState().token
  const location = useLocation()
  const getUserInfo = useGlobalStore(state => state.getUserInfo)

  const rolePermissions_u = getUserInfo()?.rolePermissions || {}
  const rolePermissions: Record<string, string[]> = {
    ...rolePermissions_u,
    login: ['login'],
    '404': ['404'],
    home: ['home']
  }

  const allowedKeys: string[] = Object.values(rolePermissions).flat()
  const allowedRouteConfig = filterRoutesWithPermissions(routeConfig, rolePermissions)

  useEffect(() => {
    const route = routeConfig.find(route => route.path === location.pathname)
    if (route?.meta?.title) document.title = route.meta.title
  }, [location])

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/login" element={token ? <Navigate to="/home" /> : LazyRoute(LoginPage)} />
      <Route path="/auto-login" element={LazyRoute(AutoLoginPage)} />
      <Route path="/quickLogin" element={LazyRoute(QuickLogin)} />
      <Route path="/lab" element={LazyRoute(LabHome)} />
      <Route path="/lab/labDetail" element={LazyRoute(LabDetail)} />
      <Route path="/lab/messageCenter" element={LazyRoute(MessageCenter)} />
      
      <Route path="/lab/certificateVerify" element={LazyRoute(CertificateVerifyResult)} />
      
      {generateRoutes(allowedRouteConfig, allowedKeys)}
      <Route path="*" element={<Navigate to="/404" />} />
    </Routes>
  )
}

export default RoutesComponent
